import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Grid, makeStyles } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import CustomPopupText from '../../shared/CustomPopupText';
import CustomDropDown from '../../shared/CustomDropDown';
import CustomTextField from '../../shared/CustomTextField';
import CustomRadioGroup from '../../shared/CustomRadioGroup';
import CustomButton from '../../shared/CustomButton';
import { types } from '../constants';
import { showProgress } from '../../../redux/actions/DealershipActions';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import useCategory from '../hooks/useCategory';
import { ErrorToast } from '../../utils/Utils';
import { validate } from '../utils';
import CustomMultiSelect from '../../shared/CustomMultiSelect';

const style = {
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '527px',
  height: '744px',
  backgroundColor: '#F2F4F7',
};

const useStyle = makeStyles({
  headerConatiner: {
    width: '527px',
    height: '72px',
    padding: '24px 16px 24px 16px',
    background: 'white',
  },
  contentContainer: {
    width: '495px',
    padding: '16px',
  },

  buttonContainer: {
    marginTop: 'auto',
    background: '#FFFFFF',
    width: '527px',
    height: '64px',
    border: '1px',
  },
});

export default function AddCategoryPopup({ isOpen, handleClose, isEdit, tabValue, categoryName, categoryId }) {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { fetchPartnerTypes } = useCategory();
  const [data, setData] = React.useState({});
  const catList = useSelector((state) => state.categoryData.categoryList);
  const [networkPartnerList, setNetworkPartnerList] = React.useState([]);
  // const networkPartnerList = useSelector((state) => state.networkPartnerData?.networkPartnerList);
  const depts = useSelector((state) => state.categoryData.selectedCategoryDeptCollections).departments;
  const content = useSelector((state) => state.categoryData.selectedCategoryDeptCollections);
  const selectedId = useSelector((state) => state.categoryData.selectedId);

  React.useEffect(() => {
    if (isEdit) {
      setData((prev) => ({ ...prev, exploreCategoryId: categoryId, name: categoryName }));
    } else if (depts?.length > 0) {
      setData({
        name: '',
        departmentId: [depts[tabValue]?.id],
        rockedNetworkPartnerId: content?.rockedNetworkPartnerId,
      });
    }
  }, [isEdit, depts, tabValue]);

  React.useEffect(() => {
    const npType = catList?.filter((item) => item?.id === content?.rockedNetworkPartnerId);
    setNetworkPartnerList(npType);
  }, [catList, content?.rockedNetworkPartnerId]);
  const handleData = ({ target }) => {
    const { name, value } = target;
    setData((prev) => ({ ...prev, [name]: value }));
  };
  const handleCategoryRequest = async (method, payload) => {
    try {
      const apiEndpoint = method === 'POST' ? apiEndpoints.CAT_CATEGORY_ADD : apiEndpoints.CAT_CATEGORY_UPDATE;
      await service[method.toLowerCase()](apiEndpoint, payload);
    } catch (error) {
      dispatch(showProgress(false));
      ErrorToast(error);
    }
  };

  const processDepartments = async () => {
    dispatch(showProgress(true));
    const method = isEdit ? 'PUT' : 'POST';
    if (data.departmentId) {
      data.departmentId?.forEach(async (id) => {
        const payload = { ...data, departmentId: id };
        await handleCategoryRequest(method, payload);
      });
    } else {
      await handleCategoryRequest(method, data);
    }
  };
  const handleSave = async () => {
    const check = validate(data);
    if (check) {
      return;
    }
    dispatch(showProgress(true));
    await processDepartments();
    handleClose();
    dispatch(showProgress(false));
    fetchPartnerTypes(selectedId);
  };
  const handleFilterUpdate = (arr) => {
    setData({ ...data, departmentId: arr });
  };
  return (
    <div>
      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            className={classes.headerConatiner}
          >
            <Grid item>
              <CustomPopupText
                text={isEdit ? 'Edit Category' : 'Add Category'}
                fontSize="20px"
                fontWeight="600"
                color="#000"
              />
            </Grid>
            <Grid item>
              <Close onClick={handleClose} style={{ cursor: 'pointer' }} />
            </Grid>
          </Grid>
          <Grid container direction="column" className={classes.contentContainer}>
            <Grid item>
              <CustomPopupText text="Category Name" required count totalWords="40" word={data?.name} />
            </Grid>
            <Grid item>
              <CustomTextField defaultValue={data?.name} handleChange={handleData} name="name" width="100%" />
            </Grid>
            <Grid item>
              <CustomPopupText text="Department" required />
            </Grid>
            <Grid item>
              {!isEdit ? (
                <CustomMultiSelect
                  name="departmentId"
                  width="100%"
                  list={depts?.filter((item) => item?.id)}
                  handleFilterChange={handleFilterUpdate}
                  selectedValue={data?.departmentId}
                />
              ) : (
                <CustomDropDown
                  name="departmentId"
                  width="100%"
                  list={depts?.filter((item) => item?.id)}
                  handleChange={handleData}
                  value={depts?.filter((dept) => depts[tabValue]?.id === dept?.id)[0]?.name}
                  disabled
                />
              )}
            </Grid>
            <Grid item>
              <Grid container direction="row" alignItems="center" spacing={4}>
                <Grid item>
                  <CustomPopupText text="Content Type" required />
                </Grid>
                <Grid item>
                  <CustomRadioGroup name="type" value={networkPartnerList[0]?.type} options={types} disabled />
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <CustomPopupText text="Select OEM" required />
            </Grid>
            <Grid item>
              <CustomDropDown
                name="oemId"
                value={networkPartnerList[0]?.title}
                width="100%"
                list={networkPartnerList}
                handleChange={handleData}
                disabled
              />
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end" style={{ height: '100%' }}>
            <Grid item className={classes.buttonContainer}>
              <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                style={{ height: '100%' }}
                spacing={1}
              >
                <Grid item>
                  <CustomButton label="Cancel" type="secondary" onClick={handleClose} />
                </Grid>
                <Grid item style={{ marginRight: '6px' }}>
                  <CustomButton label="Save" type="primary" onClick={handleSave} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
